// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"af2ec0d6","286":"c3057f55","887":"eab0443b","916":"8ce5af68","917":"25d3eeed"}[chunkId] + ".chunk.js";
};